import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "table-separator" }

import { toRefs } from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
    spacing: { default: 'py-2' }
  },
  setup(__props: any) {

const props = __props as { spacing: string }



const { spacing } = toRefs(props);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("tbody", _hoisted_1, [
    _createElementVNode("tr", null, [
      _createElementVNode("td", {
        class: _normalizeClass(_unref(spacing)),
        colspan: "420"
      }, null, 2)
    ])
  ]))
}
}

})